class FooterMobileMenu {
  constructor() {
    this.headers = document.querySelectorAll('.mobile-menu-header');
    this.init();
  }

  init() {
    this.headers.forEach(header => {
      const toggle = header.querySelector('.mobile-menu-toggle');
      const content = document.getElementById(toggle.getAttribute('aria-controls'));
      
      // Set initial state
      content.setAttribute('aria-hidden', 'true');
      content.style.maxHeight = '0px';
      
      // Handle click events
      header.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleMenu(toggle, content);
      });

      // Handle keyboard events
      toggle.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleMenu(toggle, content);
        }
      });

      // Trap focus within the expanded menu
      content.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          e.preventDefault();
          this.toggleMenu(toggle, content);
          toggle.focus();
        }
      });
    });
  }

  toggleMenu(toggle, content) {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    
    toggle.setAttribute('aria-expanded', !isExpanded);
    content.setAttribute('aria-hidden', isExpanded);
    
    if (!isExpanded) {
      // Opening animation
      content.removeAttribute('hidden');
      // Force a reflow
      content.offsetHeight;
      content.style.maxHeight = content.scrollHeight + 'px';
      
      // Focus first focusable element in the content
      const firstFocusable = content.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) {
        firstFocusable.focus();
      }
    } else {
      // Closing animation
      content.style.maxHeight = '0px';
      setTimeout(() => {
        content.setAttribute('hidden', '');
      }, 300);
    }
  }
}

// Initialize the mobile menu when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new FooterMobileMenu();
}); 